import script from "./voting-nomination-card.vue?vue&type=script&setup=true&lang=js"
export * from "./voting-nomination-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__